import { http } from '@/services/http'

export default {
  getUsers(params) {
    return http.get('/users', { params })
  },
  getUser({ id }) {
    return http.get(`/users/${id}`)
  },
  updateUser({ id, name, email, role, status, country, piAccess }) {
    return http.patch(`/users/${id}`, {
      name,
      email,
      role,
      status,
      country,
      pi_access: piAccess
    })
  },
  createUser({ email, name, role, country, piAccess }) {
    return http.post('/users', {
      email,
      name,
      role,
      country,
      status: 'enabled',
      pi_access: piAccess
    })
  },
  getCountries() {
    return http.get('/users/countries')
  },
  checkGdpr({ email, name }) {
    return http.put('/users/gdpr', {
      email: email === '' ? null : email,
      name: name === '' ? null : name
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/api/user.js